<template>
  <div></div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {
        }
    },
    mounted() {        
        this.checkSSoSession();
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        checkSSoSession() {
           let loginForm = this.SMSSO_LOGIN_FORM;
           if(document.location.href.indexOf("cpstg") > -1){
                loginForm = "http://cpstg.hanwhalife.com/hcpsso/sso_login";
           }
           //SSO세션 상태별 Redirect URL 로 이동
           let redirect_url = this.checkSession();
           //redirect_url이 null이라는건 SMSSO_LOGIN_FORM 이라는걸 의미한다.
           if(redirect_url !== ""){
               if(redirect_url !== loginForm){
                   window.location.href = redirect_url;
               }else{
                   window.location.href = redirect_url;
               }
           }else{
               window.location.href = loginForm;
           }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/sso/hcp/hcpSsoIndex.vue